import {
  Box,
  Step,
  StepLabel,
  stepLabelClasses,
  Stepper,
  stepperClasses,
  styled,
} from '@mui/material';
import StepConnector, {
  stepConnectorClasses,
} from '@mui/material/StepConnector';

export const QontoConnector = styled(StepConnector)(() => ({
  [`&.${stepConnectorClasses.root}`]: {
    display: 'contents',
  },
  [`& .${stepConnectorClasses.alternativeLabel}`]: {},
  [`& .${stepConnectorClasses.line}`]: {
    display: 'none',
  },
}));

export const StepperStyle = styled(Stepper, {
  shouldForwardProp: (prop) => prop !== 'isModal',
})(({ theme, isModal }) => {
  const getChangingProperties = () => {
    if (isModal) {
      return {
        marginTop: '12px',
        marginBottom: '20px',
        [theme.breakpoints.down('lg')]: {
          width: '100%',
          marginTop: '5px',
          marginBottom: '12px',
        },
      };
    }

    return {
      marginTop: 24,
      marginBottom: 32,
      [theme.breakpoints.down('sm')]: {
        display: 'flex',
        marginTop: 16,
      },
    };
  };

  return {
    [`&.${stepperClasses.root}`]: {
      padding: theme.spacing(0),
      justifyContent: 'center',
      ...getChangingProperties(),
    },
  };
});

export const StepStyled = styled(Step, {
  shouldForwardProp: (prop) => prop !== 'nSteps' && prop !== 'isModal',
})(({ theme, index, nSteps, isModal }) => {
  const getChangingProperties = () => {
    if (isModal) {
      return {
        [theme.breakpoints.down('lg')]: {
          width: '100%',
        },
        paddingLeft: 0,
        paddingRight: index === nSteps - 1 ? 0 : '8px',
      };
    }

    return {
      paddingLeft: '8px',
      paddingRight: '8px',
      [theme.breakpoints.down('lg')]: {
        paddingLeft: '4px',
        paddingRight: '4px',
      },
    };
  };

  return {
    ...getChangingProperties(),
  };
});

export const StepLabelStyled = styled(StepLabel, {
  shouldForwardProp: (prop) => prop !== 'isModal',
})(({ theme, isModal }) => {
  const getChangingProperties = () => {
    if (isModal) {
      return {
        [theme.breakpoints.down('lg')]: {
          width: '100%',
        },
      };
    }

    return {
      [theme.breakpoints.between('sm', 'lg')]: {
        width: '145px',
      },
      [theme.breakpoints.between('md', 'sm')]: {
        width: '145px',
      },
      [theme.breakpoints.between('xs', 'md')]: {
        width: '112px',
      },
      [theme.breakpoints.down('xs')]: {
        width: '108px',
      },
    };
  };

  const getLabelChangingProperties = () => {
    if (isModal) {
      return {
        [theme.breakpoints.down('lg')]: {
          fontSize: '12px',
        },
      };
    }

    return {
      [theme.breakpoints.down('md')]: {
        fontSize: '12px',
        textTransform: 'capitalize',
      },
    };
  };

  return {
    [`& .${stepLabelClasses.label}`]: {
      [`&.${stepLabelClasses.completed}`]: {
        color: theme.palette.colors.previousStep,
      },
      [`&.${stepLabelClasses.active}`]: {
        color: theme.palette.colors.currentStep,

        fontWeight: 'bold',
      },
      color: theme.palette.colors.nextStep,
      padding: 0,
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: 1,
      textTransform: 'uppercase',
      ...getLabelChangingProperties(),
    },
    [`& .${stepLabelClasses.iconContainer}`]: {
      display: 'none',
    },
    [theme.breakpoints.up('lg')]: {
      width: '128px',
    },
    ...getChangingProperties(),
  };
});

export const StepperLabelContainerStyled = styled(Box)(() => ({
  marginBottom: '9px',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
}));

export const StepperUnderlineContainerStyled = styled(Box, {
  shouldForwardProp: (prop) =>
    prop !== 'activeStep' &&
    prop !== 'index' &&
    prop !== 'completedColor' &&
    prop !== 'completed',
})(({ theme, activeStep, index, completedColor, completed }) => ({
  height: '5px',
  borderStyle: 'solid',
  borderRadius: '3px',
  background:
    activeStep === index
      ? theme.palette.colors.onSecondaryAndDetailBackground
      : (completedColor[completed[index]] ?? theme.palette.colors.nextStep),
}));
